import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Banner } from "@modules/banners/types";
import { BannerFormValues } from "@modules/banners/validations";
import { editBannerService } from "./service";
import { UseEditBannerMutationOptions } from "./types";

export function useEditBannerMutation(
  id: string,
  options?: UseEditBannerMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Banner, ApiError, Partial<BannerFormValues>>({
    mutationFn: (data) => editBannerService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("v1/banner_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
